/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifacts_Open_In_ChatInputs */



/**
* | output |
* | --- |
* | "Start new chat with artifact" |
*
* @param {Artifacts_Open_In_ChatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_open_in_chat = /** @type {((inputs?: Artifacts_Open_In_ChatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Open_In_ChatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuen Chat mit Artefakt starten")
	return /** @type {LocalizedString} */ ("Start new chat with artifact")
});